import { Box, StepIconProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const styles = {
  icon: (theme: Theme, isActive: boolean) => ({
    width: 20,
    height: 20,
    borderRadius: '50%',
    background: isActive
      ? theme.palette.primary.main
      : theme.palette.background.default,
  }),
};

export function StepIcon({ active, completed }: Omit<StepIconProps, 'icon'>) {
  const isActive = active || completed || false;

  return <Box sx={theme => styles.icon(theme, isActive)} />;
}
